import types, {quoteChangeActions} from '../../../actions/types'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import Immutable from 'seamless-immutable'
import {get, set} from 'lodash'
import QuoteHelper from '../../../helpers/quotes'
import purchasingTab from './purchasingTab'
import activitiesTab from './activitiesTab'
import invoicesTab from './invoicesTab'
import documents from './documents'
import newDocuments from './newDocuments'
import approvals from "reducers/quotingContext/selected/approvals"
import amendments from './amendments'
import itemDrawer from './itemDrawer'
import {createNewHistoryItem} from 'containers/quoteEditor/components/quoteHistoryView/columnDefinition'
import {DataType} from 'helpers/socket'
import pricingCalculatorDrawer from "reducers/quotingContext/selected/pricingCalculatorDrawer"

export const loading = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_QUOTE_ATTEMPT:
      return Immutable(true)
    case types.QUOTING_LOAD_QUOTE_FAILURE:
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
      return Immutable(false)
    default:
      return state
  }
}

const contactId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_SET_SELECTED_CONTACT:
      return action.contactId
    default:
      return state
  }
}

const companyId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_SET_SELECTED_CONTACT:
      return action.companyId
    default:
      return state
  }
}

export const order = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
      return action.data
    case types.QUOTING_LOAD_QUOTE_FAILURE:
      return null
    case types.CONTACTS_DETAILS_CONTACT_LOAD_ATTEMPT:
      return null
    case types.QUOTING_QUOTE_CHANGE_ORDER_STATUS_SUCCESS:
      return action.data.result
    case types.QUOTING_CONTACT_EDIT_SUCCESS:
      return Immutable({...state, contact: action.data})
    case types.QUOTING_QUOTE_UPDATE_ORDER:
    case types.QUOTING_SHOW_APPROVAL_DRAWER_FOR_ORDER:
      return action.order
    case types.QUOTING_QUOTE_UPDATE_PROPERTY:
      return set({...state}, action.key, action.value)
    case types.QUOTING_QUOTE_SAVE_SUCCESS:
      return {
        ...state,
        ...action.data.result,
      }
    default:
      return state
  }
}

export const summaryInfo = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_SUMMARY_INFO_ATTEMPT:
      return null
    case types.QUOTING_LOAD_SUMMARY_INFO_SUCCESS:
      return action.data[0]
    default:
      return state
  }
}

export const deletedItems = (state = Immutable([]), action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
    case types.QUOTING_LOAD_QUOTE_ATTEMPT:              // reset when loading another quote
      return Immutable([])

    // Anything deleted since this save was sent is still pending
    case types.QUOTING_QUOTE_SAVE_SUCCESS: {
      const confirmed = get(action, 'confirmedDeletedItems', [])
      return Immutable(state.filter(id => !confirmed.includes(id)))
    }

    case types.QUOTING_QUOTE_DELETE_ORDER_ITEM:
      return Immutable([
        ...state,
        action.orderItem.id,
      ])
    case types.QUOTING_QUOTE_DELETE_ORDER_ITEMS:
      return Immutable([
        ...state,
        ...action.orderItems.map(i => i.id),
      ])
    default:
      return state
  }
}

const revisions = combineReducers({
  fetching: (state = Immutable(false), action) => {
    switch (action.type) {
      case types.QUOTING_LOAD_REVISIONS_ATTEMPT:
        return true
      case types.QUOTING_LOAD_REVISIONS_SUCCESS:
      case types.QUOTING_LOAD_REVISIONS_FAILURE:
        return false
      default:
        return state
    }
  },
  data: (state = null, action) => {
    switch (action.type) {
      case types.QUOTING_LOAD_QUOTE_SUCCESS:
      case types.QUOTING_LOAD_QUOTE_ATTEMPT:       // reset when loading another quote
      case types.QUOTING_LOAD_REVISIONS_FAILURE:
      case types.QUOTING_LOAD_REVISIONS_ATTEMPT:
        return null
      case types.QUOTING_LOAD_REVISIONS_SUCCESS:
        return action.data
      case types.QUOTING_QUOTE_CHANGE_ORDER_STATUS_SUCCESS: {
        if (state == null) return null
        const updated = action.data.result
        return state.map(d => d.id === updated.id ? updated : d)
      }

      default:
        return state
    }
  },
})

export const editMode = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_EDIT_MODE:
      return true
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
    case types.QUOTING_LOAD_QUOTE_ATTEMPT:
      return false       // reset when loading another quote
    default:
      return state
  }
}

export const amendMode = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_TOGGLE_AMEND_MODE_ENABLE:
      return true
    case types.QUOTING_QUOTE_TOGGLE_AMEND_MODE_DISABLE:
      return false
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
    case types.QUOTING_LOAD_QUOTE_ATTEMPT:
      return false       // reset when loading another quote
    default:
      return state
  }
}

export const changesMade = (state = Immutable(false), action) => {
  if (quoteChangeActions.indexOf(action.type) !== -1) {
    return true
  } else {
    switch (action.type) {
      case types.QUOTING_LOAD_QUOTE_SUCCESS:
        return false
      case types.PIVOT_TABLE_EDIT_DATA:
      case types.PIVOT_TABLE_EDIT_DATA_MULTI:
      case types.PIVOT_TABLE_ADD_ENTITY:
        if (action.key === itemPivotTableKey) return true
        return state
      default:
        return state
    }
  }
}

export const changeLogQuote = (state = Immutable([]), action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
      return Immutable([action.data])
    case types.QUOTING_LOG_CHANGE:
      return Immutable([...state, action.quote])
    case types.QUOTING_UNDO_CHANGE:
      return Immutable(state.slice(0, -1))
    default:
      return state
  }
}

export const changeLogQuoteItems = (state = Immutable([]), action) => {
  switch (action.type) {
    case types.PIVOT_TABLE_LOAD_SUCCESS:
      if (action.key === itemPivotTableKey) {
        return Immutable([action.data])
      }
      return state
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
      return Immutable([action.data])
    case types.QUOTING_LOG_CHANGE:
      return Immutable([...state, action.quoteItems])
    case types.QUOTING_UNDO_CHANGE:
      return Immutable(state.slice(0, -1))
    case types.QUOTING_QUOTE_CHANGE_ORDER_STATUS_ATTEMPT:
      return Immutable([])
    default:
      return state
  }
}

const observingRef = (state = Immutable(null), action) => {
  switch (action.type) {

    case types.OBSERVE_SUCCESS:
      return action.dataType === DataType.ORDER
        ? action.objectId
        : state

    case types.DEOBSERVE_SUCCESS:
      return action.dataType === DataType.ORDER && action.objectId === state
        ? null
        : state

    default:
      return state
  }
}

const observingUsers = (state = {}, action) => {
  switch (action.type) {
    case types.USERS_OBSERVING_QUOTE:
    case types.USERS_OBSERVING_ORDER:
      return action.users

    case types.USERS_OBSERVING:
      return action.dataType === DataType.ORDER
        ? action.users
        : state

    case types.DEOBSERVE:
      return action.dataType === DataType.ORDER
        ? {}
        : state

    default:
      return state
  }
}

const currentTab = (state = Immutable('quote'), action) => {
  switch (action.type) {
    case types.NAVIGATION_SET_SELECTED_QUOTING_TAB:
      return action.tab
    default:
      return state
  }
}

const currentDetailsTab = (state = Immutable('Order'), action) => {
  switch (action.type) {
    case types.QUOTING_SET_DETAILS_TAB:
      return action.tab
    default:
      return state
  }
}

const createNewItem = (item, state) => ({
  ...item,
  lineItem: state.length + 1,
  lineItemLetter: QuoteHelper.getOrderItemLetter(state.length + 1),
})

export const itemPivotTableKey = 'quotingContext.selected.items'
export const orderHistoryPivotTableKey = 'quotingContext.selected.history'
export const quotingContextDeliveryNotesPivotTableKey = 'quotingContext.selected.deliveryNotes'
export const jobCardsPivotTableKey = 'quotingContext.selected.jobCards'
export const quotingContextDeliveryPivotTableKey = 'quotingContext.selected.delivery'
export const quotingContextPurchasingItemsPivotTableKey = 'quotingContext.selected.purchaseOrderItems'
export const quotingContextBillOfMaterialsPivotTableKey = 'quotingContext.selected.billOfMaterials'
export const quotingContextBillOfLabourPivotTableKey = 'quotingContext.selected.billOfLabour'

export default combineReducers({
  loading,
  order,
  contactId,
  companyId,
  summaryInfo,
  editMode,
  amendMode,
  changesMade,
  changeLogQuote,
  changeLogQuoteItems,
  deletedItems,
  activitiesTab,
  purchasingTab,
  invoicesTab,
  revisions,
  documents,
  newDocuments,
  approvals,
  amendments,
  itemDrawer,
  items: createPivotTableReducer({
    key: itemPivotTableKey,
    defaultSortColumn: Immutable('itemId'),
    defaultSortDirection: Immutable('asc'),
    pageSize: 50,
    defaultGridStretch: false,
    defaultAreAllRowsSelected: false,
    defaultCanSelectRows: false,
    retainEdits: false,
    onNewEntity: createNewItem,
  }),
  history: createPivotTableReducer({
    key: orderHistoryPivotTableKey,
    defaultSortColumn: 'timestamp',
    defaultSortDirection: 'desc',
    pageSize: 50,
    defaultGridStretch: false,
    defaultAreAllRowsSelected: false,
    defaultCanSelectRows: false,
    retainEdits: false,
    onNewEntity: createNewHistoryItem,
  }),
  jobCards: createPivotTableReducer({
    key: jobCardsPivotTableKey,
    defaultSortColumn: 'createDate',
    defaultSortDirection: 'asc',
    pageSize: 50,
    defaultGridStretch: false,
    defaultAreAllRowsSelected: false,
    defaultCanSelectRows: false,
    retainEdits: false,
    onNewEntity: () => {
    },
  }),
  deliveryNotes: createPivotTableReducer({
    key: quotingContextDeliveryNotesPivotTableKey,
    defaultSortColumn: 'createdDate',
    defaultSortDirection: 'desc',
  }),
  delivery: createPivotTableReducer({
    key: quotingContextDeliveryPivotTableKey,
    defaultSortColumn: 'createdDate',
    defaultSortDirection: 'desc',
  }),
  purchaseOrderItems: createPivotTableReducer({
    key: quotingContextPurchasingItemsPivotTableKey,
    defaultSortColumn: 'createdDate',
    defaultSortDirection: 'desc',
  }),
  observingRef,
  observingUsers,
  currentTab,
  currentDetailsTab,
  billOfMaterials: createPivotTableReducer({
    key: quotingContextBillOfMaterialsPivotTableKey,
    defaultSortColumn: 'partCode',
    defaultSortDirection: 'asc',
  }),
  billOfLabour: createPivotTableReducer({
    key: quotingContextBillOfLabourPivotTableKey,
    defaultSortColumn: 'partCode',
    defaultSortDirection: 'asc',
  }),
  pricingCalculatorDrawer,
})
